/***************************************************************************

    Copyright (C) 2020 Ravenpod, Inc.
    All rights reserved.

    This material contains CONFIDENTIAL INFORMATION
    that is the property of Ravenpod.com, Inc.
    Any unauthorized use, duplication or disclosure is prohibited.

***************************************************************************/

const greenNode = require('!!raw-loader!../assets/container-green.svg').default;
const yellowNode = require('!!raw-loader!../assets/container-yellow.svg').default;
const redNode = require('!!raw-loader!../assets/container-red.svg').default;
const greyNode = require('!!raw-loader!../assets/container-grey.svg').default;
const purpleNode = require('!!raw-loader!../assets/container-purple.svg').default;
const purpleNodeOK = require('!!raw-loader!../assets/container-purple-ok.svg').default;
const purpleNodeWarning = require('!!raw-loader!../assets/container-purple-warning.svg').default;
const purpleNodeError = require('!!raw-loader!../assets/container-purple-error.svg').default;
const blueNode = require('!!raw-loader!../assets/container-blue.svg').default;
const blueNodeOK = require('!!raw-loader!../assets/container-blue-ok.svg').default;
const blueNodeWarning = require('!!raw-loader!../assets/container-blue-warning.svg').default;
const blueNodeError = require('!!raw-loader!../assets/container-blue-error.svg').default;
const officeIcon = require('!!raw-loader!../assets/corporate.svg').default;

const funcs = {

    getNumberOfOrganizations: (endorsers, orderers) => {
        let organziations = []
        for (const endorser of endorsers) {
            if (!organziations.includes[endorser.msp_id]) {
                organziations.push(endorser.msp_id)
            }
        }
        for (const orderer of orderers) {
            if (!organziations.includes[orderer.msp_id]) {
                organziations.push(orderer.msp_id)
            }
        }
        return organziations.length
    },

    getUpAndRunningCount: (peers) => {
        let result = { total: 0, up: 0 }
        for (const peer of peers) {
            result.total += 1;
            if (peer.ping_report && peer.ping_report.reachable) {
                result.up += 1;
            }
        }
        return result;
    },

    generateNodes: (endorsers, orderers, size, highlightStatus) => {

        let orgNodeSize;
        let peerNodeSize;
        if ( !size || size == 'small') {
            orgNodeSize = 36;
            peerNodeSize = 30
        } else if ( size == 'large' ) {
            orgNodeSize = 72;
            peerNodeSize = 60
        }
        let organziations = []
        let results = []
        for (const endorser of endorsers) {
            if (!organziations.includes(endorser.msp_id)) {
                results.push({
                    id: endorser.msp_id,
                    name: endorser.msp_id,
                    _size: orgNodeSize,
                    _cssClass: 'organization',
                    svgSym: officeIcon
                })
                organziations.push(endorser.msp_id)
            }
            if (endorser.acceptance || (endorser.ping_report && endorser.ping_report.reachable)) {
                results.push({id: endorser.id, name: 'Endorser', _size: peerNodeSize, _cssClass: 'endorser', svgSym: blueNodeOK, _labelClass: 'd3-network-hidden-node-label'})
            } else if (endorser.isWarning) {
                results.push({id: endorser.id, name: 'Endorser', _size: peerNodeSize, _cssClass: 'endorser', svgSym: blueNodeWarning, _labelClass: 'd3-network-hidden-node-label'})
            } else if (endorser.hasError || (endorser.ping_report && !endorser.ping_report.reachable)) {
                results.push({id: endorser.id, name: 'Endorser', _size: peerNodeSize, _cssClass: 'endorser', svgSym: blueNodeError, _labelClass: 'd3-network-hidden-node-label'})
            } else {
                results.push({id: endorser.id, name: 'Endorser', _size: peerNodeSize, _cssClass: 'endorser', svgSym: blueNode, _labelClass: 'd3-network-hidden-node-label'})
            }
        }
        for (const orderer of orderers) {
            if ((orderer.msp_id) && !organziations.includes(orderer.msp_id)) {
                results.push({
                    id: orderer.msp_id,
                    name: orderer.msp_id,
                    _size: orgNodeSize,
                    _cssClass: 'organization',
                    svgSym: officeIcon
                })
                organziations.push(orderer.msp_id)
            }
            if (orderer.success || (orderer.ping_report && orderer.ping_report.reachable)) {
                results.push({id: orderer.id, name: 'Orderer', _size: peerNodeSize, _cssClass: 'orderer', svgSym: purpleNodeOK, _labelClass: 'd3-network-hidden-node-label'})
            } else {
                results.push({id: orderer.id, name: 'Orderer', _size: peerNodeSize, _cssClass: 'orderer', svgSym: purpleNode, _labelClass: 'd3-network-hidden-node-label'})
            }
        }
        console.log("D3 node parameters = ", results)
        return results;
    },

    generateLinks: (endorsers, orderers) => {
        let results = []
        console.log("Generating links for: ", endorsers, orderers)
        for (const endorser of endorsers) {            
            results.push({sid: endorser.id, tid: endorser.msp_id, _color: '#757575'})
        }
        for (const orderer of orderers) {
            if (orderer.msp_id) {
                results.push({sid: orderer.id, tid: orderer.msp_id, _color: '#757575'})
            }
        }
        console.log("D3 link parameters", results)
        return results;
    },

}

export default funcs